var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26.7071 17.7071C27.0976 17.3166 27.0976 16.6834 26.7071 16.2929L20.3431 9.92893C19.9526 9.53841 19.3195 9.53841 18.9289 9.92893C18.5384 10.3195 18.5384 10.9526 18.9289 11.3431L24.5858 17L18.9289 22.6569C18.5384 23.0474 18.5384 23.6805 18.9289 24.0711C19.3195 24.4616 19.9526 24.4616 20.3431 24.0711L26.7071 17.7071ZM7 18H26V16H7V18Z","fill":"currentColor","key":0}),React.createElement("circle",{"cx":"17","cy":"17","r":"16.5","stroke":"currentColor","key":1})]);
}

ChevronRightInline.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
